import { render, staticRenderFns } from "./TextAlerts.vue?vue&type=template&id=061fd543&scoped=true&"
import script from "./TextAlerts.vue?vue&type=script&lang=js&"
export * from "./TextAlerts.vue?vue&type=script&lang=js&"
import style0 from "./TextAlerts.vue?vue&type=style&index=0&id=061fd543&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061fd543",
  null
  
)

export default component.exports